module.exports = __webpack_public_path__ + "img/icon-help.6652dd14.svg";